import classNames from 'classnames/bind';
import styles from './Membership.module.css';
import {
  ADDITIONAL_MANAGEMENT_PERSONNEL,
  ADDITIONAL_PERSONNEL_AMOUNT,
  ADD_MANAGEMENT_PERSONNEL,
  ADD_PERSONNEL,
  AI_LEARNING_TOOL,
  ANNUAL,
  CANCEL_MEMBERSHIP,
  CHANGE_CARD,
  CHANGE_MEMBERSHIP,
  CLASS_MANAGEMENT_PERSONNEL,
  CREDIT_CARD,
  CURRENCY_UNIT,
  CURRENT_MEMBERSHIP,
  CURRENT_MEMBERSHIP_AMOUNT,
  HEADCOUNT,
  MEMBERSHIP,
  MEMBERSHIP_INFO,
  MONTHLY,
  NEXT_PAYMENT_DATE,
  NUMBER_OF_PEOPLE,
  PAYMENT_HISTORY,
  PAYMENT_INFO,
  RECURRING_BILLING,
  SCHEDULED_PAYMENT_AMOUNT,
  SCHEDULED_PAYMENT_AMOUNT_DESC,
  SUBSCRIPTION_PERIOD,
  UNLIMITED,
} from '../../../constants';
import { useNavigate } from 'react-router';
import useModal from '../../../hooks/useModal';
import { useGetMembershipQuery } from '../../../services/membership';
import { useEffect } from 'react';
import { formatDate } from '../../../utils/date';

export default function Membership() {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();
  const { toggleModal } = useModal();

  const { data, isLoading, refetch } = useGetMembershipQuery();

  const cancelChangeMembership = async () => {
    try {
      toggleModal({
        id: 'cancel-change-membership',
        type: 'confirm',
      });
    } catch (error) {
      console.error('Failed to cancel changing membership', error);
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading || !data) return null;

  const { membershipInfo, paymentInfo } = data;
  const {
    membershipId,
    description,
    nm,
    startDate,
    endDate,
    capacityStudent,
    aitoolService,
    capacityStudentExt,
    changeMessage,
    changeMessageYn,
    addStudentYn,
    demoYn,
  } = membershipInfo;
  const { cardNo, nextPaymentDate, price } = paymentInfo;

  const isFree = membershipId === 1;

  const membershipInfoList = [
    {
      label: CURRENT_MEMBERSHIP,
      value: description,
    },
    {
      label: SUBSCRIPTION_PERIOD,
      value: `${formatDate(startDate)} 00:00 ~ ${
        endDate !== UNLIMITED ? `${formatDate(endDate)} 23:59` : endDate
      }`,
    },
    { label: CLASS_MANAGEMENT_PERSONNEL, value: capacityStudent },
    ...(!isFree
      ? [
          { label: AI_LEARNING_TOOL, value: aitoolService },
          {
            label: ADDITIONAL_MANAGEMENT_PERSONNEL,
            value: capacityStudentExt,
          },
        ]
      : []),
  ];

  const paymentInfoList = [
    {
      label: CREDIT_CARD,
      value: cardNo,
      btn: {
        label: CHANGE_CARD,
        class: 'card_change',
        onClick: () => navigate('../change-card'),
      },
    },
    {
      label: NEXT_PAYMENT_DATE,
      value: nextPaymentDate,
      btn: {
        label: PAYMENT_HISTORY,
        class: 'payment_detail',
        onClick: () => navigate('../payment-history'),
      },
    },
    {
      label: SCHEDULED_PAYMENT_AMOUNT,
      value: price?.paymentTotalPrice.toLocaleString(),
    },
  ];

  return (
    <>
      <h2>{MEMBERSHIP}</h2>
      <div className={cx('st_membership')}>
        <div className={cx('panel')}>
          <div className={cx('panel_title')}>
            <span>{MEMBERSHIP_INFO}</span>
          </div>
          <div className={cx('panel_inner')}>
            {membershipInfoList.map(({ label, value }) => (
              <div key={label} className={cx('panel_row')}>
                <div className={cx('panel_items')}>
                  <span className={cx('sub')}>{label} : </span>
                  <span
                    className={cx('detail', {
                      aitools: label === AI_LEARNING_TOOL,
                    })}
                  >
                    {label === CURRENT_MEMBERSHIP ? (
                      <span className={cx('type_plan')}>{value}</span>
                    ) : (
                      <span>
                        {value}{' '}
                        {label.includes(NUMBER_OF_PEOPLE) && `(${HEADCOUNT})`}
                      </span>
                    )}
                  </span>
                </div>
              </div>
            ))}
            {!!changeMessageYn && !isFree && (
              <div className={cx('guide_text')}>
                <p className={cx('desc')}>
                  {/*
                  {MEMBERSHIP_CHANGE_SCHEDULE_NOTICE.replace(
                    `{membership}`,
                    '[]'
                  )} */}
                  {changeMessage}
                </p>
                {/* <button
                  type="button"
                  className={cx('btn', 'skyt', 'change_revert')}
                  onClick={cancelChangeMembership}
                >
                  <span>{CANCEL_CHANGE}</span>
                </button> */}
              </div>
            )}
          </div>
        </div>

        {!isFree && nextPaymentDate !== '-' && (
          <div className={cx('btn_wrap')}>
            <button
              type="button"
              className={cx('btn', 'skyt', 'plan_cancel')}
              onClick={() => navigate('../cancel-membership')}
            >
              <span>{CANCEL_MEMBERSHIP}</span>
            </button>
          </div>
        )}

        {!isFree && (
          <div className={cx('panel')}>
            <div className={cx('panel_title')}>
              <span>{PAYMENT_INFO}</span>
            </div>
            <div className={cx('panel_inner')}>
              {paymentInfoList.map(
                ({ label, value, btn }) =>
                  !!value && (
                    <div key={label} className={cx('panel_row')}>
                      <div className={cx('panel_items')}>
                        <span className={cx('sub')}>{label} : </span>
                        <span className={cx('detail')}>
                          <span
                            className={cx('', {
                              bold: label === SCHEDULED_PAYMENT_AMOUNT,
                            })}
                          >
                            {label === SCHEDULED_PAYMENT_AMOUNT &&
                              CURRENCY_UNIT}
                            {value}
                          </span>
                        </span>
                      </div>
                      {btn && (
                        <button
                          type="button"
                          className={cx('btn', 'skyt', btn.class)}
                          onClick={btn.onClick}
                        >
                          <span>{btn.label}</span>
                        </button>
                      )}
                    </div>
                  )
              )}
              {!!price?.paymentTotalPrice &&
                (() => {
                  const { subscribe } = price.detail;
                  return (
                    <>
                      <div className={cx('round_box')}>
                        <div className={cx('settle_items')}>
                          {(!!subscribe.membershipPrice ||
                            !!subscribe.studentServicePrice) && (
                            <div className={cx('settle_title')}>
                              <span className={cx('ico_charge')}>
                                {RECURRING_BILLING}
                              </span>
                              <span className={cx('type_plan')}>
                                {subscribe.membership.nm}
                              </span>
                              {subscribe.membership.nm !== 'free' && (
                                <span className={cx('')}>
                                  (
                                  {subscribe.membership.paymentPeriod ===
                                  'month'
                                    ? MONTHLY
                                    : ANNUAL}
                                  )
                                </span>
                              )}
                              {
                                <span className={cx('type_class')}>
                                  + {ADD_PERSONNEL}
                                </span>
                              }
                            </div>
                          )}
                          {!!subscribe.membershipPrice && (
                            <div className={cx('items')}>
                              <span className={cx('sub')}>
                                {CURRENT_MEMBERSHIP_AMOUNT}
                              </span>
                              <span className={cx('detail', 'bold')}>
                                + {CURRENCY_UNIT}
                                {subscribe.membershipPrice.toLocaleString()}
                              </span>
                            </div>
                          )}
                          {!!subscribe.studentServicePrice && (
                            <div className={cx('items')}>
                              <span className={cx('sub')}>
                                {ADDITIONAL_PERSONNEL_AMOUNT}
                              </span>
                              <span className={cx('detail', 'bold')}>
                                + {CURRENCY_UNIT}
                                {subscribe.studentServicePrice.toLocaleString()}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={cx('guide_text')}>
                        <p className={cx('desc')}>
                          {SCHEDULED_PAYMENT_AMOUNT_DESC}
                        </p>
                      </div>
                    </>
                  );
                })()}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
